
import { Icon } from "@portal/lib/icons/icons";

import { Button } from "@portal/BaseComponents/Button/AntButton";
import { HideWrapper } from "@portal/BaseComponents/HideWrapper/HideWrapper";
import { usePrivileges } from "@portal/hooks/use-privilleges";
import useOpen from "@portal/hooks/useOpen";
import { userConfigAtom } from "@portal/store/userConfig/userConfig";
import { Empty } from "antd";
import { useAtomValue } from "jotai";
import { TitleComponent } from "../Title";
import { ProfileCards } from "../style";
import AddNewItemModal from "./AddAndEditModal";
import { CustomerContactItem } from "./CustomerContactItem";

const t = {
  MyContacts: "My Contacts",
  PrimaryContact: "Primary Contact",
  OtherContacts: "Other Contacts",
  SecondaryContacts: "Secondary Contacts",
  NewContact: "Contact",
};

const plusIcon = (
  <Icon
    icon={['far','plus-circle']}
    style={{ paddingRight: "var(--space-4)" }}
  />
);

function CustomerContacts() {
  const customer = useAtomValue(userConfigAtom);
  const { open, onClose, toggleOpen } = useOpen({ open: false });
  const { getContactPrivilege } = usePrivileges();
  const isContacts = Boolean(customer.user_details?.customer.contacts?.length);
  const Title = (
    <TitleComponent
      title={t.MyContacts}
      internalContactsLength={
        customer.user_details?.customer?.contacts?.length ?? 0
      }
    />
  );

  const EmptyComp = (
    <Empty
      description="No Contacts available"
      image={Empty.PRESENTED_IMAGE_SIMPLE}
    />
  );
  const newContactButton = (
    <HideWrapper hide={!getContactPrivilege("CONTACT_CREATE")}>
      <Button
        type="text"
        icon={plusIcon}
        onClick={toggleOpen}
        style={{ padding: 0 }}
      >
        {t.NewContact}
      </Button>
    </HideWrapper>
  );

  return (
    <ProfileCards
      style={{ minHeight: "100%" }}
      title={Title}
      actions={getContactPrivilege("CONTACT_CREATE") ? [newContactButton] : undefined}
      layout_margin="m1"
    >
      {isContacts
        ? customer.user_details?.customer.contacts?.map((contact) => {
            return (
              <CustomerContactItem
                key={contact.id}
                item={contact}
                id={contact.id}
              />
            );
          })
        : EmptyComp}
      <AddNewItemModal modalType="ADD" open={open} onClose={onClose} />
    </ProfileCards>
  );
}

export { CustomerContacts };
